import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import EvolutionMobile from "./EvolutionMobile";
import EvolutionDesktop from "./EvolutionDesktop";

function Evolution({ app, config }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });
  return isMobile ? (
    <EvolutionMobile app={app} config={config} />
  ) : (
    <EvolutionDesktop app={app} config={config} />
  );

}

Evolution.defaultProps = {
  app: null,
  config: {},
};

Evolution.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Evolution;
